import { useAxios } from "@/hooks/useAxios"
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export const useCanDeleteExamGroup = (id: string, isOpen: boolean) => {

    const axios = useAxios();
    const {t} = useTranslation();

    const canDeleteExamGroup = async () => {
        try {
            const { data } = await axios.get(`/api/examgroup/CanDeleteExamGroup/${id}`);
            return data;
        } catch (error) {
            throw new Error(t("messages.error.canDeleteExamGroup"));
        }
    }

    return useQuery({queryKey: ["canDeleteExamGroup", id], queryFn: canDeleteExamGroup, enabled: !!isOpen, gcTime: 10000});

}